export default __webpack_public_path__ + "static/media/build-img.98a6e994.png";